import React from 'preact/compat';
import { ComponentChildren } from 'preact';

export default function FormHelp({ children }: FormHelpProps) {
    return (
        <div className='form__help'>
            {children}
        </div>
    );
}

type FormHelpProps = {
    children: ComponentChildren,
};
